<template>
  <div class="content-wrapper">
    <TemplateBookRefund v-if="isReadyToDraw" />

    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />
  </div>
  <!-- /.content-wrapper -->
</template>

<script>
import TemplateBookRefund from "@/views/Templates/MyTickets/TemplateBookRefund";

import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "BookRefund",
  components: {
    TemplateBookRefund: TemplateBookRefund,
  },

  setup() {
    const store = useStore();
    const route = useRoute();

    const isReadyToDraw = ref(false);

    onMounted(async () => {
      try {
        await API.getMyticketDetail(route.params.book_group_id);
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "BookRefund onMounted()",
          JSON.stringify(err)
        );
        console.log("error in BookRefund", err);
      }
    });
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const book = computed(() => store.getters["ticketing/book"]);

    watchEffect(() => {
      if (masterBook.value.id && book.value.id) {
        isReadyToDraw.value = true;
      }
    });

    return {
      isReadyToDraw,
    };
  },
};
</script>
